import { useSettingsStore } from '@/store/useSettingsStore';

export const useRedirect = () => {
  const getURLToBaseDomain = (path: string) => {
    const settingsStore = useSettingsStore();
    const origin = window.location.origin;
    const baseDomain = settingsStore.baseDomain;
    const secondaryBaseDomain = settingsStore.secondaryBaseDomain;

    if (baseDomain === secondaryBaseDomain || !baseDomain || !secondaryBaseDomain) {
      return false;
    }

    if (origin.search(secondaryBaseDomain) > -1) {
      const url = origin.replace(secondaryBaseDomain, baseDomain);
      return `${url}/${path}`;
    }

    return false;
  };

  return { getURLToBaseDomain };
};
